import React from "react";

interface MaskedStatusForActiveNewProps {
    data: any;
}

interface MaskedStatusForActiveNewState {
    activeStatus: string;
}

class MaskedStatusForActiveNew extends React.Component<MaskedStatusForActiveNewProps> {
    state: MaskedStatusForActiveNewState;
    constructor(props: MaskedStatusForActiveNewProps) {
        super(props);
        this.state = {
            activeStatus: this.props.data.data.active ? "Yes" : "No",
        };
    }

    render() {
        return (
            <div>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="mr-2 d-flex">
                        <span className="status-message-color">{this.state.activeStatus}</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default MaskedStatusForActiveNew;
